// extracted by mini-css-extract-plugin
export default {"root":"UnderwritingStepCard_root__D6faq"};